module.exports = __webpack_public_path__ + "assets/media/invitation-sent.87194437.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/invitation-sent.svg
// module id = 306
// module chunks = 0